export default "<div class=\"\" style=\"\">\n   \n</div>"